export default __webpack_public_path__ + "static/media/Countdown_1.99e88f84.png";